import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import useApiUrls from "../../useApiUrls";

const AddImageInCampagin = () => {
  const navigate = useNavigate();
  const { id, name } = useParams(); // Get the campaign ID from the URL
  const { getUrlByOperation, error: urlError } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    CampaignId: id,
    Remark: "",
    Active: true,
    Name: name,
    File: null,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");

  // Handle input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "File") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    // Validation
    if (!formData.Remark || !formData.File) {
      setMessage("Please fill in all required fields.");
      return;
    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;

    // Create a new FormData object
    const data = new FormData();

    data.append("CampaignId", formData.CampaignId);
    data.append("Remark", formData.Remark);
    data.append("Active", formData.Active);
    data.append("Name", formData.Name);
    data.append("File", formData.File);

    try {
      const CampaignInfoInsert = getUrlByOperation("CampaignInfoInsert");
      const response = await axios.post(
        CampaignInfoInsert,
        data,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage("Image added successfully!");

      setTimeout(() => {
        navigate(`/showcampaign/${id}/${name}`);
      }, 3000);
    } catch (error) {
      console.error(error);
      setMessage("Failed to add image.");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Image</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group"></div>
                            <div className="form-group">
                              <label>Image Description</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.Remark}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="Remark"
                              />
                            </div>
                            <div className="form-group">
                              <label>Upload File</label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={handleChange}
                                name="File"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "Image added successfully!" ? (
       <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Please fill in all required fields." ? (
       <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default AddImageInCampagin;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}